export enum ErrorCustomMutationTypes {
    ADD_ERROR = "ADD_ERROR",
    CLEAR_ERRORS = "CLEAR_ERRORS",
    NEW_ERROR = "NEW_ERROR",
    DISPLAY_ERROR = "DISPLAY_ERROR",
}